import moment from 'moment';
import { FC } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../../shared/dialog/dialog.styles';
import { withPatientIvStatusDialogProvider } from '../../../hooks/use-patient-iv-status-dialog/hoc';
import { usePatientIvStatusDialog } from '../../../hooks/use-patient-iv-status-dialog/hook';
import { PatientIvStatusDialog } from '../../patient-iv-status-dialog';
import { AppointmentEndedMessage } from '../../shared/appointment-ended-message/appointment-ended-message';
import { ManuallyVerifiedButton } from '../../shared/manually-verified-button';
import { RunVerificationButton } from '../../shared/run-verification-button';
import { SelfPayButton } from '../../shared/self-pay-button';
import { BoldText } from '../../styles';

const UnknownPatientStatusDialog: FC = () => {
  const { opened, onClose, isLoading, patientInfo, selectedIvSummary, appointment } = usePatientIvStatusDialog();

  return (
    <PatientIvStatusDialog
      opened={opened}
      title="Needs Attention"
      subtitle={
        <>
          <BoldText>{`${patientInfo?.firstName} ${patientInfo?.lastName}`}</BoldText>
          {selectedIvSummary?.dateReceived && (
            <>&nbsp;- Run {moment.utc(selectedIvSummary.dateReceived).local().format('MMM D hA')}</>
          )}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '10px 0 20px 0', display: 'block' }}>
        {selectedIvSummary?.ediErrorMessage ?? (
          <>
            We couldn't confirm the verification status of this patient. Please reach out to the payer directly to
            manually verify the patient or mark them as self-pay.
          </>
        )}
      </DialogSubTitle>
      <AppointmentEndedMessage />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <RunVerificationButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </PatientIvStatusDialog>
  );
};

export default withPatientIvStatusDialogProvider(UnknownPatientStatusDialog);
